import { render, staticRenderFns } from "./EditQuestionnaireBasic.vue?vue&type=template&id=0aa3625e"
import script from "./EditQuestionnaireBasic.vue?vue&type=script&lang=js"
export * from "./EditQuestionnaireBasic.vue?vue&type=script&lang=js"
import style0 from "./EditQuestionnaireBasic.vue?vue&type=style&index=0&id=0aa3625e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports